import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const DEFECTS_MENU = {
  key: ROUTES.DEFECTS.ROOT,
  label: TITLES[ROUTES.DEFECTS.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.DEFECTS.APARTMENTS,
      label: TITLES[ROUTES.DEFECTS.APARTMENTS],
      environment: [DEV, STAGE, PROD],
    },
    {
      key: ROUTES.DEFECTS.ENG_NETWORKS,
      label: TITLES[ROUTES.DEFECTS.ENG_NETWORKS],
      environment: [DEV, STAGE, PROD],
    },
  ],
};
